(function($) {
    'use strict';

    let $body = $(document.body);

    // Handle the wishlist flyout.
    $body.on('click', '.sp-flyout, .woocommerce-tab-content', function(e) {
        if (e.target !== this) {
            return;
        }

        $body.trigger('sp_flyout/hide');
    });

    $body.on('click', '.tab-inner-close', function() {
        $body.trigger('sp_flyout/hide');
    });

    $body.on('click', '.tab-toggle', function() {
        var windowWidth = $(window).outerWidth();

        $('body').attr('data-pos', $(window).scrollTop());

        $('html').addClass('flyout--open');

        const flyout = $(this).attr('data-flyout');
        const flyoutSelector = '.woocommerce-tab-content[data-flyout="%s"]'
            .replace('%s', flyout);
        $('.woocommerce-tab-content-outer').removeClass('closed');
        $(flyoutSelector).prop('inert', false).addClass('visible');
        $('.action-bar.fixed').addClass('hidden');
    });

    if (!$('html').hasClass('flyout--open')) {
        $body.on('click', '.sp-flyout-toggle', function() {
            $('div[data-flyout=' + $(this).attr('data-flyout') + ']')
                .prop('inert', false)
                .addClass('visible')
                .find('input:checked')
                .parent()
                .addClass('active');

            $(this).closest('.composite_component').addClass('flyout-visible');
            $('.action-bar.fixed').addClass('hidden');

            $('body').attr('data-pos', $(window).scrollTop());
            $('html').addClass('flyout--open');
        });
    }

    $body.on('click', '.swatch-anchor', function() {
        $('body').removeClass('triggerComponent');
        var selected_attribute_name = $(this)
            .closest('.attribute_options')
            .find('.selected_attribute_name');
        var selected_attribute_image = $(this)
            .closest('.attribute_options')
            .find('.selected_attribute_image');
        var swatch_label = $(this).attr('title');
        var swatch_image = $(this).find('img').attr('src');
        var swatch_bg_color = $(this).css('background-color');

        if ($(this).parent().hasClass('selected')) {
            selected_attribute_name.each(function() {
                var textNode = $(this).contents().filter(function() {
                    return this.nodeType === 3 && this.nodeValue.trim();
                })[0];
                if (textNode) {
                    textNode.nodeValue = swatch_label;
                } else {
                    $(this).append(swatch_label);
                }
            }).parent().addClass('active');
            selected_attribute_image.css({
                'background-image': 'url(' +
                    swatch_image +
                    ')', 'background-color': swatch_bg_color,
            }).addClass('visible').find('img').remove();
        } else {
            selected_attribute_name.each(function() {
                var textNode = $(this).contents().filter(function() {
                    return this.nodeType === 3 && this.nodeValue.trim();
                })[0];
                if (textNode) {
                    textNode.nodeValue = '';
                }
            }).parent().removeClass('active');
            selected_attribute_image.css({
                'background-image': 'url(' +
                    swatch_image +
                    ')', 'background-color': swatch_bg_color,
            }).removeClass('visible').find('img').remove();
        }

        $body.trigger('sp_flyout/hide');
    });

    $body.on('change', '.attribute_options .radio-option', function() {
        var selected_attribute_label = $(this).next().text();
        $(this)
            .parent()
            .addClass('active')
            .siblings()
            .removeClass('active');

        if (this.checked == true) {
            $(this)
                .closest('.attribute_options')
                .find('.selected_attribute_name')
                .each(function() {
                    var textNode = $(this).contents().filter(function() {
                        return this.nodeType === 3 && this.nodeValue.trim();
                    })[0];
                    if (textNode) {
                        textNode.nodeValue = selected_attribute_label;
                    } else {
                        $(this).append(selected_attribute_label);
                    }
                })
                .parent()
                .addClass('active');
        }
    });

    class SP_Flyout {
        constructor() {
            $body.on(
                'click',
                '.sp-flyout-close, .tab-close',
                this.sp_flyout_hide,
            );

            $(document).on('sp_flyout/hide', this.sp_flyout_hide);

            $('.sp-flyout, .woocommerce-tab-content').prop('inert', true);

            this.initKeyboardAccessibility();
        }

        initKeyboardAccessibility = () => {
            const interactiveSelectors = [
                '.sp-flyout-toggle',
                '.tab-toggle',
                '.sp-flyout-close',
                '.tab-close',
                '.tab-inner-close',
                '.save-selection',
            ].join(', ');

            const nativelyFocusable = ['button', 'a', 'input', 'select', 'textarea'];

            $(interactiveSelectors).each(function() {
                if (!nativelyFocusable.includes(this.tagName.toLowerCase()) && !$(this).attr('tabindex')) {
                    $(this).attr('tabindex', '0');
                }
            });

            $body.on('keydown', interactiveSelectors, function(e) {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    $(this).trigger('click');
                }
            });

            $(document).on('keydown', function(e) {
                if (e.key === 'Escape') {
                    $body.trigger('sp_flyout/hide');
                }
            });
        };

        sp_flyout_hide = () => {
            var scrolltop = $('body').attr('data-pos');
            $(window).scrollTop(scrolltop);
            $('.sp-flyout__content, .woocommerce-tab-content-outer')
                .addClass('closed');

            setTimeout(function() {
                $('.sp-flyout, .woocommerce-tab-content')
                    .removeClass('visible')
                    .prop('inert', true);
                $('.sp-flyout__content, .woocommerce-tab-content-outer')
                    .removeClass('closed');
                $('.composite_component').removeClass('flyout-visible');
                $('.action-bar.fixed').removeClass('hidden');
                $('html').removeClass('flyout--open');
            }, 500);
        };
    }

    new SP_Flyout();

}(jQuery));
